import { Col, Collapse, Row } from "antd"
import cx from "clsx"
import { t } from "i18next"
import { Fragment } from "react"
import theme from "utils/themeVars"
import { Group, Icon, Steps, Text, Tooltip } from ".."
import { InfoBlock } from "../../custom"
import styles from "./index.module.less"

export default function DetailBar(props) {
  const {
    className,
    detailData,
    listStyle,
    listData,
    collapsible,
    collapseHeader,
    stepsProps,
    detailHeader,
    evenly = false,
    separator = true,
    onlyInfoBlock,
    customComponent = () => {},
    customComponentObj,
    detailContainerClass,
    noDetailHeader,
    expandIconTitle,
    bgColor = theme["primary-light"],
    borderColor = theme["primary-color"],
  } = props

  const renderGroup = () => {
    return (
      <>
        {!noDetailHeader && detailHeader}
        <div>
          <Row
            className={cx(
              styles.outlookInfo,
              !separator && styles.hideSep,
              evenly && styles.equalSpace,
              detailContainerClass
            )}
            justify="space-between"
          >
            {detailData?.map((item, i) => {
              if (item.component) return item.component
              return (
                <Fragment key={i}>
                  <Col className={styles.sep} />
                  <Col key={`${item.value}-${i}`}>
                    <Text color={theme["gray700"]} block>
                      {item.label}
                    </Text>
                    <Text block>{item.value}</Text>
                    {item?.subText && (
                      <Text color={theme["gray700"]} block>
                        {item.subText}
                      </Text>
                    )}
                  </Col>
                </Fragment>
              )
            })}
          </Row>
        </div>
      </>
    )
  }

  const customDot = (dot, { index }) => {
    const title = stepsProps?.data[index]?.title
    const stageUpdatedAt = stepsProps?.data[index]?.stageUpdatedAt

    return stageUpdatedAt ? (
      <Tooltip title={`${title} ${t("Date")}: ${stageUpdatedAt}`}>
        <div>
          <Icon icon="FaCheckCircle" />
        </div>
      </Tooltip>
    ) : (
      <Icon icon="FaCheckCircle" />
    )
  }

  return (
    <>
      {collapsible ? (
        <Collapse
          className={cx(className, styles.outlook)}
          style={{ backgroundColor: bgColor, border: `1px dashed ${borderColor}` }}
          // style={{ ...style }}
          expandIcon={({ isActive }) =>
            !expandIconTitle ? (
              <Icon
                icon="MdKeyboardArrowDown"
                size="1.8em"
                style={{ transform: `rotate(${isActive ? 180 : 0}deg)`, color: borderColor }}
                color={borderColor}
                hasBackground={false}
              />
            ) : (
              <div>
                <Text type="primary">{(isActive ? t("Hide") : t("Show")) + " " + expandIconTitle}</Text>
                <Icon
                  icon="MdKeyboardArrowDown"
                  size="1.8em"
                  color={borderColor}
                  style={{ transform: `rotate(${isActive ? 180 : 0}deg)`, color: borderColor }}
                />
              </div>
            )
          }
          expandIconPosition="end"
          collapsible="header"
        >
          <Collapse.Panel
            header={
              stepsProps ? (
                <Group gap="16px">
                  <div className={styles.stepsScrollWrap}>
                    <Steps
                      size="small"
                      progressDot={customDot}
                      labelPlacement="vertical"
                      {...stepsProps}
                    />
                  </div>
                  {renderGroup()}
                </Group>
              ) : (
                <Group gap="16px">
                  {collapseHeader && <div>{collapseHeader}</div>}
                  {renderGroup()}
                </Group>
              )
            }
          >
            {listData && (
              <InfoBlock
                className={cx(listStyle === "grid" && styles.infoBlockGrid)}
                size="small"
                data={listData}
                customComponent={data => customComponent(data)}
                customComponentObj={customComponentObj}
              />
            )}
          </Collapse.Panel>
        </Collapse>
      ) : (
        <Group
          className={cx("p-16", styles.outlook, className)}
          style={{ backgroundColor: bgColor, border: `1px dashed ${borderColor}` }}
          gap="16px"
        >
          {onlyInfoBlock ? (
            <InfoBlock
              className={cx(listStyle === "grid" && styles.infoBlockGrid)}
              size="small"
              data={listData}
              customComponent={data => customComponent(data)}
              customComponentObj={customComponentObj}
            />
          ) : (
            renderGroup()
          )}
        </Group>
      )}
    </>
  )
}
